<template>
  <div class="upload_proof">
    <customer-service :position="95/2"></customer-service>
    <div class="header">
      <p>* 每个教师资格证和手机号只可申领一次</p>
      <p>* 我们会对您的个人信息严格保密</p>
    </div>
    <div class="main">
      <div class="main_phone">
        <p class="phone">
          <span class="phone_label">当前申领账号 </span><span class="phone_num">{{ phone }}</span>
        </p>
        <p class="tip">申领成功后请使用当前申领的手机号领取课程</p>
      </div>
      <div class="main_upload">
        <h3 class="title">资质证明</h3>
        <van-form>
          <van-field
            :class="{ error: errMsg.userName }"
            :rules="[{ validator: validatorUserName }]"
            v-model="form.userName"
            required
            :error-message="errMsg.userName"
            name="姓名"
            label="本人真实姓名"
            placeholder="请输入教师资格证上的姓名"
          ></van-field>
          <van-field
            :class="{ error: errMsg.idCard }"
            :rules="[{ validator: validatorIdCard }]"
            v-model="form.idCard"
            required
            :error-message="errMsg.idCard"
            name="身份证"
            label="本人身份证号码"
            placeholder="请输入身份证号码"
          ></van-field>
          <van-field
            :class="{ error: errMsg.certificate }"
            :rules="[{ validator: validatorCertificate }]"
            v-model="form.certificate"
            required
            :error-message="errMsg.certificate"
            name="教师资格证"
            label="教师资格证号码"
            placeholder="请输入资格证号码"
          ></van-field>
          <van-field
            :class="{ error: errMsg.schoolName }"
            :rules="[{ validator: validatorSchoolName }]"
            v-model="form.schoolName"
            required
            :error-message="errMsg.schoolName"
            name="任职学校名称"
            label="任职学校名称"
            placeholder="请输入您任职的学校名称"
          ></van-field>
          <div class="upload" @click="clickUpload">
            <div class="upload_item card">
              <div class="label">教师资格证照片</div>
              <div :class="['upload_img', { upload_error: errMsg.idCardImg }]">
                <van-uploader
                  v-model="cardImg.card"
                  :after-read="afterReadIdCard"
                  :max-count="1"
                />
                <p class="tip" v-if="cardImg.card.length === 0">点击上传图片</p>
              </div>
              <div class="error_tip">{{ errMsg.idCardImg }}</div>
            </div>
          </div>
        </van-form>
      </div>
      <button class="main_submit" @click="addInfo('0')" :disabled='disabled' ref="pStyle">确认申领</button>
    </div>
  </div>
</template>
<script>
import customerService from '../components/customerService'
import config from '../config'
export default {
  name: 'uploadProof',
  components: {
    customerService
  },
  data() {
    return {
      pageuid: 'activitiesPage3',
      phone: '',
      form: {
        userName: '', // 姓名
        idCard: '', // 身份证
        certificate: '', // 教师资格证
        idCardImg: '', // 教师资格证
        userCardImg: '', // 本人手持教师资格证
        schoolName: '' // 公立学校名称
      },
      cardImg: {
        card: [], // 教师资格证
        userCard: [] // 本人手持教师资格证
      },
      uploading: [
        {
          url: 'https://img.yzcdn.cn/vant/leaf.jpg',
          status: 'uploading',
          message: '上传中...'
        }
      ],
      uploadFailed: [
        {
          url: 'https://img.yzcdn.cn/vant/tree.jpg',
          status: 'failed',
          message: '上传失败'
        }
      ],
      errMsg: {
        userName: '', // 姓名
        idCard: '', // 身份证
        certificate: '', // 教师资格证
        idCardImg: '', // 教师资格证
        userCardImg: '', // 本人手持教师资格证
        schoolName: '' // 任职学校
      },
      errMsgConfig: {
        userName: '请输入2-4位汉字', // 姓名
        idCard: '请输入18位数字、字母', // 身份证
        certificate: '请输入正确的资格证编码', // 教师资格证
        idCardImg: '请上传图片', // 教师资格证
        userCardImg: '请上传图片', // 本人手持教师资格证
        schoolName: '请输入学校名称' // 任职学校
      },
      isUpdate: false, // 是否为更新申领信息
      hasUploadSuccess: true, // 是否上传成功
      disabled: false // 提交按钮的默认态
    }
  },
  mounted() {
    this.init()
    this.$xesLogger.loadMsg({
      pageuid: this.pageuid
    })
  },
  methods: {
    /**
     * 页面初始化
    */
    async init() {
      this.checkLogin()
      const res = await this.$api.getInfo()
      if (res.stat === 1 && res.code === 0) {
        this.isUpdate = true
        const { data } = res
        this.form.userName = data.name
        this.form.idCard = data.card
        this.form.certificate = data.teacherCard
        this.form.idCardImg = data.cardImage
        this.form.userCardImg = data.teacherImage
        this.form.schoolName = data.schoolName
        this.cardImg.card.push({ url: data.cardImage })
        this.cardImg.userCard.push({
          url: data.teacherImage
        })
      } else if (res.stat === 1 && res.code === 300) {
        // 无数据 没有提交记录
        this.isUpdate = false
      } else {
        this.$toast(res.msg || '获取数据失败')
      }
    },
    /**
       * 检测登陆态： 目的获取用户手机号
       */
    async checkLogin() {
      const res = await this.$api.checkLogin()
      if (res.stat === 1) {
        this.phone = res.data.user_info.phone
      } else {
        this.$router.replace({
          name: 'home'
        })
      }
    },
    validatorSchoolName(val) {
      this.errMsg.schoolName = val ? '' : this.errMsgConfig.schoolName
    },
    /**
       * 姓名校验：2-4位汉字
       * @param val
       * @returns {boolean}
       */
    validatorUserName(val) {
      const reg = /^[\u2E80-\u9FFF]{2,4}$/
      const res = reg.test(val)
      this.errMsg.userName = res ? '' : this.errMsgConfig.userName
      return res
    },
    /**
       * 18位数字或字母
       * @param val
       */
    validatorIdCard(val) {
      const reg = /^[\dA-Z]{18}$/i
      const res = reg.test(val)
      this.errMsg.idCard = res ? '' : this.errMsgConfig.idCard
      return res
    },
    /**
       * 17位数字或字母
       * @param val
       * @returns {boolean}
       */
    validatorCertificate(val) {
      const reg = /^[\dA-Z]+$/i
      const res = reg.test(val)
      this.errMsg.certificate = res ? '' : this.errMsgConfig.certificate
      return res
    },
    /**
       * 教师资格证 读取完毕
       * @param file
       */
    async afterReadIdCard(file) {
      this.form.idCardImg = await this.uploadImg('card', file)
      this.errMsg.idCardImg = ''
    },
    /**
     * 本人手持教师资格证 读取完毕
     * @param file
     */
    async afterReadUserCard(file) {
      this.form.userCardImg = await this.uploadImg('userCard', file)
      this.errMsg.userCardImg = ''
    },
    /**
     * 图片上传
     * @type card: 教师资格证，userCard: 本人手持教师资格证
     * @param file
     * @returns {Promise<*>}
     */
    async uploadImg(type, file) {
      const validFile = Array.isArray(file) ? file[0] : file
      this.cardImg[type] = this.uploading
      this.hasUploadSuccess = false
      const formData = new FormData()
      formData.append('file', validFile.file)
      const res = await this.$api.uploadImg({
        file: formData
      })
      const { data } = res
      if (data.code === 0 && data.stat === 1) {
        this.cardImg[type] = [validFile]
        this.hasUploadSuccess = true
        return data.data.path
      } else {
        this.hasUploadSuccess = true
        this.$toast(data.msg)
        this.cardImg[type] = this.uploadFailed
        return ''
      }
    },

    /**
     * 提交前的表单校验
     */
    validatorSubmit(item) {
      const form = this.form
      if (!form[item]) {
        this.errMsg[item] = this.errMsgConfig[item]
        return false
      } else {
        return true
      }
    },
    /**
       * 提交信息 需要登陆态
       * @param confirm “0” 否 1 是  不传默认是 "0" 首次提交
       * @returns {Promise<void>}
       */
    async addInfo(confirm) {
      this.$xesLogger.clickMsg({
        params: {
          pageuid: this.pageuid,
          clickid: 2,
          action: 'click_submit_uv',
          clickname: '点击提交按钮'
        }
      })

      if (!this.hasUploadSuccess) {
        this.$toast('图片上传中...')
        return
      }
      const form = this.form
      // 校验必填表单项是否为空
      if (!this.validatorSubmit('userName') || !this.validatorSubmit('idCard') || !this.validatorSubmit('certificate') || !this.validatorSubmit('schoolName')) {
        this.$toast('请完整填写申领信息')
        return
      }

      if (!form.idCardImg || this.cardImg.card.length === 0) {
        this.$toast('请完整填写申领信息')
        this.errMsg.idCardImg = this.errMsgConfig.idCardImg
        return
      }
      // if (!form.userCardImg || this.cardImg.userCard.length === 0) {
      //   this.$toast('请完整填写申领信息')
      //   this.errMsg.userCardImg = this.errMsgConfig.userCardImg
      //   return
      // }
      // 校验是否有不符合要求的表单项
      const { userName, idCard, certificate, idCardImg, userCardImg } = this.errMsg
      if (userName || idCard || certificate || idCardImg || userCardImg) {
        this.$toast('请完整填写申领信息')
        return
      }
      // 防止用户重复点击提交按钮
      this.disabled = true
      if (this.disabled) {
        this.$refs.pStyle.style.background = '#f3f3f4'
        this.$refs.pStyle.style.color = '#212831'
      }
      const params = {
        name: form.userName,
        card: form.idCard,
        teacherCard: form.certificate,
        cardImage: form.idCardImg,
        teacherImage: 'https://mr.xesimg.com/biz-growth-storage/file/20210508/f5e767a91c73546096164f2bb14506da.png',
        schoolName: form.schoolName,
        sourceId: config.sourceId,
        confirm
      }
      let res
      if (this.isUpdate) {
        res = await this.$api.modifyInfo(params)
      } else {
        res = await this.$api.addInfo(params)
      }
      if (res.stat === 1) {
        this.disabled = false
        this.checkReceiveCode(res.code, res.msg)
      } else {
        this.disabled = false
        this.$toast(res.msg)
      }
    },
    /**
       * 提交接口返回的code值和msg
       * @param code
       * @param msg
       */
    checkReceiveCode(code, msg) {
      switch (Number(code)) {
        case 0:
          // 提交信息
          this.$router.replace({
            name: 'submitSuccess'
          })
          break
        case 11003:
          this.$xesAlert({
            title: '提示',
            message: msg
          })
          break
        case 11002:
          this.$xesAlert({
            type: 'confirm',
            title: msg,
            message: this.form.certificate,
            sureText: '确认使用',
            cancelText: '取消',
            onSure: () => {
              // 确认无误，确认提交
              this.addInfo('1')
            },
            onCancel: () => {
              // 检查输入
              console.log('检查输入')
            }
          })
          break
        default:
          this.$toast(msg || '请求错误')
          break
      }
    },
    /**
       * 点击两个上传图片按钮中任意一个按钮 的日志
       */
    clickUpload() {
      this.$xesLogger.clickMsg({
        params: {
          pageuid: this.pageuid,
          clickid: 1,
          action: 'click_upload_uv',
          clickname: '点击两个上传图片按钮中任意一个按钮'
        }
      })
    }
  }
}
</script>
<style lang="less">
.upload_proof {
  font-size: 26/2px;
  font-weight: 400;
  font-family: PingFang SC Regular, PingFang SC Regular-Regular;
  line-height: 43/2px;
  color: #6d6963;

  .header {
    padding: 28/2px 40/2px 18/2px;
    background: #fef0dc;
  }

  .main {
    padding: 47/2px;

    .main_phone {
      .phone {
        font-size: 30/2px;
        font-weight: 500;
        color: #333;

        .phone_num {
          font-size: 42/2px;
          color: #6d6963;
        }
      }

      .tip {
        font-size: 26/2px;
        color: #c8a465;
      }
    }

    .main_upload {
      padding-top: 24/2px;
      margin-top: 30/2px;
      border-top: solid 1px #ebebeb;

      .title {
        font-size: 30/2px;
        font-weight: 500;
        line-height: 50/2px;
        color: #e52c30;
      }

      .van-form {
        .van-cell {
          padding: 10px 0;
        }

        .van-cell::after {
          border: none;
        }

        .van-cell--required::before {
          content: "";
        }

        .error {
          .van-field__value {
            border: 1px solid #e52c30;
          }
        }

        .van-field {
          margin: 6px 0;

          .van-field__label {
            width: 110px;
            height: 65/2px;
            font-size: 30/2px;
            font-weight: 500;
            line-height: 65/2px;
            color: #666;
          }

          .van-field__value {
            height: 65/2px;
            padding: 0 29/2px;
            font-size: 28/2px;
            line-height: 65/2px;
            background: #f8f6f9;
            border-radius: 5px;

            .van-field__error-message {
              font-size: 30/2px;
              line-height: 1;
            }
          }
        }

        .upload {
          display: flex;

          .upload_item {
            flex: 1;

            .label {
              margin: 8px 0;
              font-size: 30/2px;
              font-weight: 500;
              color: #333;
            }

            .upload_img {
              // width: 308/2px;
              // height: 273/2px;
              padding-top: 39/2px;
              text-align: center;
              border: 1px dotted #e5e5e5;
              border-radius: 10px;

              .van-uploader__upload,
              .van-uploader__preview-image {
                width: 231/2px;
                height: 174/2px;
                margin: 0;
              }

              .van-uploader__preview-delete::before {
                font-size: 50/2px;
              }

              .tip {
                margin-top: 3px;
                font-size: 24/2px;
                font-weight: 500;
                color: #999;
              }
            }

            .upload_error {
              border: 1px dotted #e52c30;
            }

            .error_tip {
              text-align: center;
              color: #e52c30;
            }
          }

          .card {
            .van-icon-photograph::before {
              width: 231/2px;
              height: 174/2px;
              line-height: 174/2px;
              background-color: white;
              background-image: url("../assets/images/card_upload.png");
              background-size: cover;
            }
          }

          // .teacherCard {
          //   .van-icon-photograph::before {
          //     width: 231/2px;
          //     height: 174/2px;
          //     line-height: 174/2px;
          //     background-color: white;
          //     background-image: url("../assets/images/teacherCard_upload.png");
          //     background-size: cover;
          //   }
          // }
        }
      }
    }

    .main_submit {
      width: 615/2px;
      height: 80/2px;
      margin: 40px auto 0;
      margin-left: 10.25px;
      font-size: 30/2px;
      font-weight: 400;
      font-family: FZLanTingHeiS-DB1-GBK Regular, FZLanTingHeiS-DB1-GBK Regular-Regular;
      line-height: 80/2px;
      text-align: center;
      color: #fff;
      background: #00aced;
      border-radius: 44/2px;
    }
  }
}
</style>
